/**
 * *Negative* regexp for `article` of a good in Warehouse.
 *
 * Matches anything but **russian letters**, **english letters** and **digits**.
 *
 * Should be used with `string.replace()` function.
 *
 * Simple pattern: `/[^a-zA-Zа-яА-ЯёЁ0-9]/gm`
 *
 * Optimized: `/[^\dA-Za-zЁА-яё]/gm`
 */
export const articleNegativeRegex = /[^\dA-Za-zЁА-яё]/gm;
/**
 * Regexp for `article` of a good in Warehouse.
 *
 * Matches only **russian letters**, **english letters** and **digits**.
 *
 * Simple pattern: `/[a-zA-Zа-яА-ЯёЁ0-9]/gm`
 *
 * Optimized: `/[\dA-Za-zЁА-яё]/gm`
 */
export const articleRegex = /[\dA-Za-zЁА-яё]/gm;
/**
 * Regexp that matches everything after the first *Space* char including the *Space* itself.
 */
export const fromFirstSpaceRegex = / .*/;
/**
 * Removes all chars after first space char and the space char itself. Then removes everything that is not *letter* or
 * *number* and transforms the result to uppercase.
 *
 * Rules from BR:
 *
 * `12A345 67890` => `12A345`
 *
 * `12-345 67-890` => `12345`
 *
 * `123Ф45 67 890` => `123Ф45`
 *
 * `L1234567890  ` => `L1234567890`
 *
 * @param article
 * @returns
 */
export function getCleanedArticle(article) {
    return article?.replace(fromFirstSpaceRegex, '').replace(articleNegativeRegex, '').toLocaleUpperCase();
}
